"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionResponse = void 0;
var BulkActionResponse;
(function (BulkActionResponse) {
    let type;
    (function (type) {
        type["REJECT_DEPLOYMENTS"] = "reject_deployments";
        type["OUTREACH_DEPLOYMENTS"] = "outreach_deployments";
        type["REMOVE_DEPLOYMENTS"] = "remove_deployments";
        type["UPDATE_DEPLOYMENTS"] = "update_deployments";
        type["SET_DEPLOYMENTS_CHARGED_FLAG"] = "set_deployments_charged_flag";
        type["SET_CLIENT_NOT_CHARGED_FLAG"] = "set_client_not_charged_flag";
        type["EXPORT"] = "export";
        type["EXPORT_ELIGIBLE_CREATORS"] = "export_eligible_creators";
        type["EXPORT_CREATORS"] = "export_creators";
        type["EXPORT_AGENCIES"] = "export_agencies";
        type["TRIGGER_MIXMAX_SEQUENCE"] = "trigger_mixmax_sequence";
        type["SEND_EMAIL_SENDGRID"] = "send_email_sendgrid";
        type["RESUME_DEPLOYMENT"] = "resume_deployment";
    })(type = BulkActionResponse.type || (BulkActionResponse.type = {}));
    let parentType;
    (function (parentType) {
        parentType["SYSTEM"] = "system";
        parentType["GROUP"] = "group";
    })(parentType = BulkActionResponse.parentType || (BulkActionResponse.parentType = {}));
    let entityType;
    (function (entityType) {
        entityType["ACCOUNT"] = "account";
        entityType["ADVERTISER"] = "advertiser";
        entityType["CAMPAIGN"] = "campaign";
        entityType["GROUP"] = "group";
        entityType["DEPLOYMENT"] = "deployment";
    })(entityType = BulkActionResponse.entityType || (BulkActionResponse.entityType = {}));
})(BulkActionResponse = exports.BulkActionResponse || (exports.BulkActionResponse = {}));
